import { useState } from "react";

import { Box, Button } from "@chakra-ui/react";
import { useMerchant } from "@/hooks/useMerchant";
import { usePermissions } from "@/hooks/usePermissions";
import { useMutateSubscriptionGuests } from "../hooks/useMutateSubscriptionGuests";
import { useFetchRewardRecipients } from "../hooks/useFetchRewardRecipients";
import { useDownloadSubscriptionReports } from "../hooks/useDownloadSubscriptionReports";
import MonthlyCostReportModal from "./MonthlyChargesReportModal";
import UploadFileModal from "./UploadFileModal";

const Buttons = (): JSX.Element => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCostReportModalOpen, setIsCostReportModalOpen] = useState(false);

  const { merchant } = useMerchant();
  const { isEditor } = usePermissions();
  const { getUploadUrl, guestBatch, resetBatch } =
    useMutateSubscriptionGuests();
  const { rewardRecipients } = useFetchRewardRecipients();
  const { downloadRewardRecipientsReport } = useDownloadSubscriptionReports();

  const uploadFile = async (file: File): Promise<string> => {
    if (!merchant?.id) throw new Error("Merchant ID missing");

    const { uploadUrl, reference } = await getUploadUrl.mutateAsync({
      rentalsMerchantId: merchant.id,
    });

    const response = await fetch(uploadUrl, {
      method: "PUT",
      body: file,
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(`Upload failed (${response.status}): ${errorText}`);
    }

    return reference;
  };

  return (
    <>
      <Box display="flex" gap="1rem">
        <Button
          size="sm"
          variant="outline"
          hidden={rewardRecipients.length === 0}
          onClick={() => downloadRewardRecipientsReport(rewardRecipients)}
        >
          Reporte Ganadores Premio
        </Button>
        <Button
          size="sm"
          variant="outline"
          onClick={() => setIsCostReportModalOpen(true)}
        >
          Reporte de Pagos
        </Button>
        <Button
          size="sm"
          variant="outline"
          hidden={!isEditor || guestBatch?.status !== "processing"}
          onClick={() => setIsModalOpen(true)}
        >
          Ver estado de la carga
        </Button>
        <Button
          size="sm"
          onClick={() => setIsModalOpen(true)}
          hidden={!isEditor || guestBatch?.status === "processing"}
        >
          Agregar invitados
        </Button>
      </Box>

      <UploadFileModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        guestBatch={guestBatch}
        uploadFile={uploadFile}
        resetBatch={resetBatch}
      />

      <MonthlyCostReportModal
        open={isCostReportModalOpen}
        onClose={() => setIsCostReportModalOpen(false)}
      />
    </>
  );
};

export default Buttons;
